export default __webpack_public_path__ + "static/media/ic_edit.343c7f6f.svg";